import { AccordionProps, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReactElement } from 'react';
import { AddressFilesDropzone } from 'src/components';
import { SiteDocumentationAccordion } from 'src/components/SidePanelTabs/SiteDocumentation/components/site-documentation-accordion';
import { FILES_SECTION_MAX_WIDTH } from 'src/components/SidePanelTabs/SiteDocumentation/site-documentation.constants';
import type { Address } from 'src/graphql';

const FilesSectionContainer = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'asAside',
})<{ asAside: boolean }>(({ asAside }) => ({
  width: '100%',
  maxWidth: asAside ? FILES_SECTION_MAX_WIDTH : '100%',
  flexShrink: 0,
  flexBasis: asAside ? FILES_SECTION_MAX_WIDTH : '100%',
  alignSelf: asAside ? 'flex-start' : 'stretch',
}));

interface FilesSectionProps {
  asAside: boolean;
  expanded: boolean;
  onChange: AccordionProps['onChange'];
  filesCount: number;
  onFileCountChange: (value: number) => void;
  isFormDisabled: boolean;
  address?: Partial<Address> | null;
  hasAccessToAutofillSiteDocumentation: boolean;
  onAutoFillClicked?: () => void | Promise<void>;
  isAutoFillLoading: boolean;
}

export const FilesSection = ({
  asAside,
  expanded,
  onChange,
  filesCount,
  onFileCountChange,
  isFormDisabled,
  address,
  hasAccessToAutofillSiteDocumentation,
  onAutoFillClicked,
  isAutoFillLoading,
}: FilesSectionProps): ReactElement => (
  <FilesSectionContainer asAside={asAside}>
    <SiteDocumentationAccordion
      title={`Files${filesCount > 0 ? ` (${filesCount})` : ''}`}
      expanded={expanded}
      onChange={onChange}
    >
      <AddressFilesDropzone
        disabled={isFormDisabled}
        address={address}
        onFileCountChange={onFileCountChange}
        onAutoFillClicked={
          hasAccessToAutofillSiteDocumentation && !isFormDisabled
            ? onAutoFillClicked
            : undefined
        }
        isAutoFillLoading={isAutoFillLoading}
      />
    </SiteDocumentationAccordion>
  </FilesSectionContainer>
);
